import { SET_CAROUSEL_DATA } from './types'

// Открыть карусель с массивом изображений
export const openCarousel = (payload) => ({ type: SET_CAROUSEL_DATA, payload})

// Открыть карусель с конкретным активным слайдом
export const openCarouselWithSlide = (images, initialSlide = 0) => ({ 
  type: SET_CAROUSEL_DATA, 
  payload: { images, initialSlide } 
})

export const closeCarousel = () => ({ type: SET_CAROUSEL_DATA, payload: null})